import Accordion from 'react-bootstrap/Accordion';
import { connect } from 'react-redux';

const mapStateToProps = state => {
  return {
    dealers: state.dealers,
  };
}

const Disclaimer = ({ dealers, children }) => {

  const { current, selected } = dealers;
  const dealer = current || selected;
  var dcp = false;
  if (dealer && !children) {
    dcp = dealer.dataCollectionPolicy;
  }
  
  return (
    <Accordion flush className="pb-5 data-collection">
      <Accordion.Item eventKey="0">
        <Accordion.Header>See our Data Privacy statement here</Accordion.Header>
        <Accordion.Body className="px-0 py-3 aui-small">
          {dcp ? <div dangerouslySetInnerHTML={{ __html: dcp}} /> : children ? null : <p>
              Audi Australia, a division of Volkswagen Group Australia Pty Ltd, will collect, hold and use your personal information for the purpose(s) set out above. Audi may disclose your personal information to Dealers, related companies or third parties that provide us with services, including to overseas locations (such as Germany). If you consent, Audi and Audi Dealers may also use your personal information to send you communications concerning products, offers, news and events. Please note that Audi and Audi Dealers are separate organisations, and that Dealers will handle your information in accordance with their own privacy policies. Our Privacy Policy explains how you can request access to and the correction of your personal information and how you may make a privacy complaint to us. For full details, see our <a href="http://www.audi.com.au/privacypolicy" target="_blank" rel="noopener noreferrer" className="aui-textlink">Privacy Policy</a>.
          </p>}
          {children}
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
}

export default connect(mapStateToProps)(Disclaimer);
